import { call, select, SelectEffect, StrictEffect, Effect } from 'redux-saga/effects';
import { getCurrentScene, getScene, getScenes } from 'modules/scenes';
import { Scene, SceneType } from 'types/Scene';
import { getImageSize, getVideoSize } from 'utils/getContentSize';
import { getPlayer } from 'utils/PlayerContext';

export type SavedTimeline = {
  sceneId?: Scene['id'];
  sceneTime?: number;
};

export function* isSceneExists(sceneId: string): Generator<SelectEffect, boolean, Scene[]> {
  const scenes = yield select(getScenes);
  return scenes.some((scene: Scene) => scene.id === sceneId);
}

export function* isSameTaskId(
  sceneId: string,
  uploadTaskId: string
): Generator<SelectEffect, boolean, Scene> {
  const scene = yield select(getScene(sceneId));
  return scene?.uploadTaskId === uploadTaskId;
}

export function* getSize(
  sceneType: SceneType,
  src: string
): Generator<StrictEffect, { width: number; height: number }, { width: number; height: number }> {
  return sceneType === SceneType.VIDEO
    ? yield call(getVideoSize, src)
    : yield call(getImageSize, src);
}

export function* saveTimeline(): Generator<SelectEffect, SavedTimeline, any> {
  const player = getPlayer();
  const currentScene: Scene = yield select(getCurrentScene);
  const currentTime: number = player.time;

  if (!currentScene) {
    return {};
  }

  const { id: sceneId } = currentScene;
  const sceneTime = currentTime - currentScene.start;

  return {
    sceneId,
    sceneTime
  };
}

export function* restoreTimeline({
  sceneId,
  sceneTime
}: SavedTimeline): Generator<Effect, undefined, any> {
  const scenes: Scene[] = yield select(getScenes);
  const scene = scenes.find(item => item.id === sceneId);

  if (!scene) {
    return;
  }

  const newTime = scene.start + sceneTime;
  const player = getPlayer();
  player.setTime(newTime);
}
